var exports = {
  "w": "xa15a2ab7--e558e0--loader",
  "x": "xa15a2ab7--e558e0--skeleton-animation",
};

module.exports = exports;
